export const parseYearPickerValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return new Date(value.getFullYear(), 0, 1);
  }

  if (typeof value === 'number' && value >= 1000 && value <= 9999) {
    return new Date(value, 0, 1);
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (/^\d{4}$/.test(trimmed)) {
      return new Date(Number(trimmed), 0, 1);
    }

    const isoYear = trimmed.match(/^(\d{4})-\d{2}-\d{2}/);
    if (isoYear) {
      return new Date(Number(isoYear[1]), 0, 1);
    }

    const parsed = new Date(trimmed);
    if (!Number.isNaN(parsed.getTime())) {
      return new Date(parsed.getFullYear(), 0, 1);
    }
  }

  return null;
};

export const toYearPickerDate = (value) => {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
    return null;
  }
  return new Date(value.getFullYear(), 0, 1);
};
